// Copyright (c) 2017 Deere & Company

import AuditClaim from '@deere/cps-it.warranty-model-factory/lib/audit-claim';
import t from 'tcomb';

const AuditClaims = t.list(AuditClaim, 'AuditClaims');

export const getDefaultState = () => new AuditClaims([]);

export default AuditClaims;



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/state/audit-claims.js